(() => {
	angular
		.module('main')
		.controller('PaymentsOverviewController', PaymentsOverviewController);

	PaymentsOverviewController.$inject = [
		'$scope',
		'$rootScope',
		'jobDataService',
		'timeService',
		'messageService',
		'validationService',
		'emailService',
		'invoicesDataService',
		'templateRequestsService',
		'fileUploadService'
	];

	function PaymentsOverviewController(
		$scope,
		$rootScope,
		jobDataService,
		timeService,
		messageService,
		validationService,
		emailService,
		invoicesDataService,
		templateRequestsService,
		fileUploadService
	) {
		$scope.emailDataToSave = {};
		clearAttachments();

		function clearAttachments() {
			$scope.attachmentsData = {
				attachments: [],
				filesSize: 0
			};
		}

		// Email methods
		$scope.retrySendMail = function() {
			emailService.callLastEmailFn();
		};

		$scope.showSendPaymentReceipt = function(payment) {
			$scope.paymentReceiptId = payment.id;
			delete $scope.sendMessage;
			$scope.sendMessage = { emailTo: payment.email ? [payment.email] : [] };
			if (payment.secondaryEmail) {
				$scope.sendMessage.emailTo.push(payment.secondaryEmail);
			}

			templateRequestsService.getTemplates('all').subscribe(
				data => {
					if (data) {
						$scope.emails = data;
						if ($scope.emails) {
							$scope.choosenEmail =
								$scope.emails.find(
									item =>
										item.emailTemplateType ===
										'RECEIPT_OF_PAYMENT_EMAIL_TEMPLATE'
								) || {};
						}
						$('#sendInvoiceModal')
							.modal('show')
							.on('shown.bs.modal', function() {
								const input = $(this).find('input');
								const select = $(this).find('select');

								validationService.isModalClosePrevented(input);
								validationService.isModalClosePrevented(select);
							});
					}
				},
				err => messageService.showDefaultErrorMessage(err)
			);
		};

		$scope.toggleViewCc = function(state) {
			if ($scope.sendMessage && $scope.sendMessage.emailCc) {
				$scope.sendMessage.emailCc = [];
			}

			$scope.showCcField = state !== undefined ? state : !$scope.showCcField;
		};

		$scope.addSubjectVariable = function($event, id) {
			const el = document.getElementById(id);
			$scope.sendMessage.emailSubject = emailService.addSubjectVariable(
				el,
				$event
			);
		};

		$scope.setEmailData = (newData, object, property) => {
			$scope[object][property] = newData;
		};

		$scope.sendPaymentReceipt = function() {
			const maxSize = 10; // 10Mb

			if (
				$scope.attachmentsData &&
				$scope.attachmentsData.filesSize > maxSize
			) {
				messageService.showToaster('w_0', 'attachments');
				return false;
			}

			$scope.sendMessage.templateId = $scope.choosenEmail
				? $scope.choosenEmail.id
				: null;
			$scope.sendMessage.emailText = $rootScope.addMaiStyling(
				$scope.sendMessage.emailText
			);

			const mailData = emailService.prepareEmails($scope.sendMessage);
			if (!emailService.validateMails(mailData)) {
				return;
			}

			$scope.emailDataToSave = Object.assign({}, $scope.sendMessage, mailData);
			delete $scope.emailDataToSave.emailCc;

			const obj2save = angular.copy($scope.emailDataToSave);

			$scope.sendMessage.emailCc = $scope.showCcField ? obj2save.emailCc : '';

			const storedFiles = $scope.attachmentsData.attachments.filter(
				file => file.id
			);
			const uploadedFiles = $scope.attachmentsData.attachments.filter(
				file => !file.id
			);

			const dataToSend = {
				sendMessageData: $scope.emailDataToSave,
				storedFiles,
				uploadedFiles
			};

			$scope.disableBtnOnSend = true;
			invoicesDataService
				.sendInvoiceEmail(dataToSend, 'receipt', $scope.paymentReceiptId)
				.finally(() => ($scope.disableBtnOnSend = false))
				.subscribe(
					data => successSendReceipt(data),
					err => errorSendReceipt(err)
				);

			function successSendReceipt(data) {
				$('#sendInvoiceModal').modal('hide');
				$scope.showCcField = false;

				$scope.$evalAsync();

				for (const prop in $scope.sendMessage) {
					$scope.sendMessage[prop] = '';
				}

				if ($scope.attachmentsData && $scope.attachmentsData.attachments) {
					if ($scope.attachmentsData.attachments.length) {
						$scope.attachmentsData.attachments.length = 0;
					}
				}
				messageService.showToaster('s_11', 'payments');
			}

			function errorSendReceipt({ status, error }) {
				$scope.disableBtnOnSend = false;
				const { errorMessage, errorTitle } = error;
				let errorCode, errorPlace, value;

				if (status >= 400 && status < 500 && errorMessage) {
					if (errorMessage === 'Email text should contain an invoice link') {
						errorCode = 'e_7';
						errorPlace = 'editInvoice';
					} else if (errorTitle) {
						messageService.showErrorFromBackend(errorTitle, errorMessage);
						return;
					} else {
						errorCode = 'e_2';
						errorPlace = 'general';
						value = errorMessage;
					}
				} else {
					errorCode = 'e_0';
					errorPlace = 'general';
				}
				messageService.showToaster(errorCode, errorPlace, value);
			}
		};

		$scope.$watch('choosenEmail', newValue => {
			if (typeof newValue !== 'undefined' && newValue !== null) {
				templateRequestsService
					.getTemplates('full_template', newValue.id)
					.subscribe(data => successGetEmail(data));
			}
		});

		function successGetEmail(email) {
			if (email) {
				$scope.sendMessage.emailSubject = email.subject;
				$scope.sendMessage.emailText = email.text;
				$scope.sendMessage.emailCc = '';

				if (email.storedAttachments && email.storedAttachments.length) {
					$scope.attachmentsData = {
						attachments: fileUploadService.convertAttachmentsToShow(
							email.storedAttachments
						)
					};
				} else {
					clearAttachments();
				}
			}
		}

		$scope.disableDragDrop = function() {
			return true;
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/paymentsOverviewController.js